
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 24 24","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M19.266 10.294h2.616v10.887H10.894v-2.209a1.042 1.042 0 01-.523-.902v-3.11l-2.767-.405-.284 2.489h-.006l-.034.338a1.05 1.05 0 01-.154.532l-2.09 2.753a1.074 1.074 0 01-1.468.361 1.054 1.054 0 01-.368-1.456l1.94-2.504v-4.452c0-.01.004-.014.004-.022 0-.017-.004-.031-.004-.048v-.015c0-.026.005-.054.006-.08.003-.062.008-.122.018-.183.002-.015.001-.028.004-.042l.006-.021c.088-.49.317-.957.317-.957l.823-2.488-1.174.487-1.11 2.015a1.068 1.068 0 01-1.437.474c-.53-.262-.744-.9-.48-1.424l1.33-2.452c.139-.277.395-.48.699-.555l.588-.224 2.368-.901a.984.984 0 01.26-.033h2.631c.408 0 .78.226.96.587l1.256 2.523h1.804c.59 0 1.07.45 1.07 1.037 0 .588-.48 1.037-1.07 1.037h-2.466c-.405 0-.777-.226-.96-.587l-.742-1.461-.88 3.03 2.422.743-.007.015.406.117c.438.143.683.55.683 1.006v3.876c0 .193-.063.362-.15.52h.673v-2.076h2.092v-2.073h2.093v-2.073h2.093v-2.074zM9.064 5.628a1.823 1.823 0 01-1.832-1.814C7.232 2.812 8.052 2 9.064 2c1.011 0 1.831.812 1.831 1.814 0 1.003-.82 1.814-1.831 1.814z"}})])
          )
        }
      }
    